import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Router from "./Router";
import { BrowserRouter, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Cookies from "universal-cookie";
import Footer from "./components/Footer";

import "react-toastify/dist/ReactToastify.css";
import "./components/ToastMessageLatest.css";
import "react-datepicker/dist/react-datepicker.css";
import ToastMessage from "./components/ToastMessage";
import { applySiteFavicon } from "./common/Funcation";
import disableDevtool from "disable-devtool";
const cookies = new Cookies();

const PUBLIC_PATHS = ["/login", "/change/password", "/maintenance"];
const POPUP_PATHS = [
  "/risk-bet-details",
  "/risk-downline-pl",
  "/risk-player-bets",
  "/risk-fancy-run-position",
];

function AppLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const authToken = cookies.get("skyToken");
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const domainDetails = useSelector((e: any) => e.domainDetails);
  const menuCount = useSelector((e: any) => e.menuCount);
  const modalHeight = useSelector((e: any) => e.modalHeight);
  const [vhMultiple, setVhMultiple] = useState(1);

    // Log modal height from Redux whenever it changes
    useEffect(() => {
      // console.log("[App.tsx] modalHeight from Redux:", modalHeight);
    }, [modalHeight]);

  // Dynamically grow vh: first 600px = 100vh base.
  // Above 600px → each 600px block split into 5 fifths (120px each = +20vh):
  //   remainder 1–119   → +20vh
  //   remainder 120–239 → +40vh
  //   remainder 240–359 → +60vh
  //   remainder 360–479 → +80vh
  //   remainder 480+    → +100vh
  useEffect(() => {
    if (!modalHeight || modalHeight <= 0) {
      setVhMultiple(1);
      return;
    }
    let pages: number;
    if (modalHeight <= 600) {
      pages = 1; // 0–600px → 100vh base
    } else {
      const overflow = modalHeight - 600;            // how much above 600px base
      const fullBlocks = Math.floor(overflow / 600); // complete 600px blocks → +100vh each
      const remainder = overflow % 600;              // leftover in current block (0–599)
      // fifth thresholds: 120px per fifth → +20vh per fifth
      let extra = 0;
      if      (remainder === 0)   extra = 0;    // exact block boundary
      else if (remainder < 120)   extra = 0.2;  // +20vh
      else if (remainder < 240)   extra = 0.4;  // +40vh
      else if (remainder < 360)   extra = 0.6;  // +60vh
      else if (remainder < 480)   extra = 0.8;  // +80vh
      else                        extra = 1;    // +100vh
      pages = 1 + fullBlocks + extra;
    }
    setVhMultiple(pages);
    console.log(
      `[App.tsx] vhMultiple: ${pages} (${pages * 100}vh) — modalHeight=${modalHeight}`,
    );
  }, [modalHeight]);
  const isPublicPage = PUBLIC_PATHS.includes(location.pathname.toLowerCase());
  const isPopupPage = POPUP_PATHS.includes(location.pathname);
  const isLoggedIn = !!isAuthenticated?.isLogin && !!authToken;
  const showChrome = !isPublicPage && !isPopupPage && isLoggedIn;
  const headerHeight = menuCount < 14 ? 107 : 137;

  useEffect(() => {
    applySiteFavicon(domainDetails);
  }, [domainDetails]);

  // disableDevtool()
  useEffect(() => {
    if (!authToken) {
      dispatch({
        type: "AUTHENTICATION",
        payload: { isLogin: false, token: "" },
      });
    }
    if (isPublicPage) {
      document.body.classList.add("login_screen");
      document.documentElement.classList.add("login_screen");
    } else {
      document.body.classList.remove("login_screen");
      document.documentElement.classList.remove("login_screen");
    }
    // eslint-disable-next-line
  }, [authToken, isPublicPage]);

  // DevTools detection — blocks all open methods, bypasses local/dev environments
  useEffect(() => {
    const hostname = window.location.hostname;
    const isExempt = hostname === "localhost" || hostname === "mysky247.xyz" || hostname === "ag.jitbo.site";
    if (isExempt) return;

    let devToolsOpen = false;
    const interval = setInterval(() => {
      const start = performance.now();
      // Use Function constructor so build tools cannot strip the debugger statement
      // eslint-disable-next-line no-new-func
      new Function("debugger")();
      const elapsed = performance.now() - start;
      if (elapsed > 100 && !devToolsOpen) {
        devToolsOpen = true;
        window.location.replace("https://www.google.com");
      } else if (elapsed <= 100) {
        devToolsOpen = false;
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {showChrome ? <Header /> : null}
      <ToastMessage />
      <div
        style={{
          position: "relative",
          minHeight: `calc(${vhMultiple * 100}vh - ${headerHeight}px)`,
        }}
      >
        <Router />
        {showChrome && location.pathname === "/" ? <Footer /> : null}
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;

/**
 * this code snippet going to use for disable site when user open console
 var $el = function (sel: any) {
        return document.querySelector(sel)
    };
    var isMac = navigator.platform.toLowerCase().indexOf('mac') > -1,
        openedRatio = isMac ? 0.85 : 1.2, // for console.error
        openedRatio = isMac ? 1.6 : 1.5, //for console.log 
        startedOpenedRatio = isMac ? 0.5 : 0.8,
        firstTest: any,
        inter: string | number | NodeJS.Timeout | undefined;

    if (window.location.hostname !== 'localhost') {
        window.addEventListener('load', function () {
            setTimeout(init, 1000);
        })
    }

    function init() {
        firstTest = testDevTools();
        // $el('.ConsoleOpen')!.innerHTML = firstTest;
        $el('.manual')!.addEventListener('click', function (e: { preventDefault: () => void; }) {
            e.preventDefault();
            stopCheck();
            // $el('.ConsoleOpen').innerHTML = testDevTools();
        })
        startCheck();
    }

    function testDevTools() {
        var t = performance.now();
        for (var i = 0; i < 100; i++) {
            // console.log('1');
            console.error('1');
            // console.clear();
        }
        return performance.now() - t;
    }

    function startCheck() {
        stopCheck();
        inter = setInterval(function () {
            var test = testDevTools(),
                ratio = test / firstTest,
                opened = ratio > openedRatio;
            // $el('.ConsoleOpen')!.innerHTML = 'Chrome Console is - ' + (opened ? 'Opened' : 'Closed');
            $el('.ConsoleOpen')!.style.display = opened ? 'block' : 'none';
            if (ratio < startedOpenedRatio) { firstTest = test; }
        }, 1000);
    }

    function stopCheck() {
        clearInterval(inter);
    }
 */
